import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';

// third-party
import ReactApexChart from 'react-apexcharts';

// chart options
const areaChartOptions = {
    chart: {
        height: 450,
        type: 'area',
        toolbar: {
            show: false
        }
    },
    dataLabels: {
        enabled: false
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    grid: {
        strokeDashArray: 0
    }
};

// ==============================|| INCOME AREA CHART ||============================== //

const IncomeAreaChart = ({ slot, data }) => {
    const theme = useTheme();

    const { primary, secondary } = theme.palette.text;
    const line = theme.palette.divider;

    const [options, setOptions] = useState(areaChartOptions);

    useEffect(() => {
        setOptions((prevState) => ({
            ...prevState,
            colors: [theme.palette.primary.main, theme.palette.primary[700]],
            xaxis: {
                categories:
                    slot === 'month'
                        ? Object.keys(data.requests.last12Months).map((d) => d.substring(0,1).toUpperCase() + d.substring(1))
                        : Object.keys(data.requests.last7).map((d) => d.substring(0,1).toUpperCase() + d.substring(1)),
                labels: {
                    style: {
                        colors: [
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary,
                            secondary
                        ]
                    }
                },
                axisBorder: {
                    show: true,
                    color: line
                },
                tickAmount: slot === 'month' ? 11 : 7
            },
            yaxis: {
                labels: {
                    style: {
                        colors: [secondary]
                    }
                }
            },
            grid: {
                borderColor: line
            },
            tooltip: {
                theme: 'light'
            }
        }));
    }, [primary, secondary, line, theme, slot]);

    const [series, setSeries] = useState([]);

    useEffect(() => {
        setSeries([
        {
            name: 'Requests',
            data: slot === 'month' ? Object.values(data.requests.last12Months).map((d,i)=> Object.values(d)[0]) : Object.values(data.requests.last7).map((d,i)=> Object.values(d)[0])
        },
        {
            name: 'Users',
            data: slot === 'month' ? Object.values(data.users.last12Months).map((d,i)=> Object.values(d)[0]) : Object.values(data.users.last7).map((d,i)=> Object.values(d)[0])
        },
        {
            name: 'Subscribers',
            data: slot === 'month' ? Object.values(data.subscribers.last12Months).map((d,i)=> Object.values(d)[0]) : Object.values(data.subscribers.last7).map((d,i)=> Object.values(d)[0])
        },
        {
            name: 'Sales',
            data: slot === 'month' ? Object.values(data.sales.last12Months).map((d,i)=> Object.values(d)[0]) : Object.values(data.sales.last7).map((d,i)=> Object.values(d)[0])
        }
        ]);
    }, [slot]);

    return <ReactApexChart options={options} series={series} type="area" height={450} />;
};

IncomeAreaChart.propTypes = {
    slot: PropTypes.string
};

export default IncomeAreaChart;
